import React from 'react'
import { FloatingInspectorButton, FloatingInspectorButtonProps, MainText } from '../FloatingInspectorButton'
import { useTranslation } from 'react-i18next'


export interface TextFixedWidthProps
  extends Pick<FloatingInspectorButtonProps, 'onClick' | 'selected' | 'disabled' | 'showBorder' | 'tooltipText' | 'placementTooltip' | 'marginTooltip'> {
    text: string
  }

const TextFixedWidth: React.FC<TextFixedWidthProps> = ({ text, onClick, selected, disabled, tooltipText, placementTooltip, marginTooltip }) => {
  const [t] = useTranslation()
  return (
  <FloatingInspectorButton
    onClick={onClick}
    selected={selected}
    disabled={disabled}
    widthType={'FixedTextOnly'}
    showBorder={true}
    tooltipText={tooltipText}
    placementTooltip={placementTooltip}
    marginTooltip={marginTooltip}
  >
    <MainText>{t(text)}</MainText>
  </FloatingInspectorButton>
)
}

export default TextFixedWidth